module.exports = __webpack_public_path__ + "img/blue-bullet.f268a653.svg";